import React from 'react';
import { EnvironmentOutlined } from '@ant-design/icons';
import { TbPlane } from 'react-icons/tb';

// "(TLV) Tel Aviv" — with only one of the two known (e.g. an airport restored
// from the URL by its code) just that one, never "(undefined)".
const airportText = (code?: string, name?: string) => {
  if (code && name) return `(${code}) ${name}`;
  return code || name || '';
};

export const AirportElement = ({ data }: { data: any }) => {
  return (
    <div
      className={`auto-complete-airport-element ${
        data?.type === 'airport' ? 'indented' : ''
      }`}
    >
      <div className="type-icon-wrapper">
        {data?.type === 'city' && <EnvironmentOutlined />}
        {data?.type === 'airport' && <TbPlane />}
      </div>
      <div className="element-info-wrapper">
        <span className="name">
          {airportText(data?.iata_code, data?.name)}
        </span>
        {data.country && <span className="description">{data.country}</span>}
      </div>
    </div>
  );
};
